import { SideSurface } from './SideSurface';

export default SideSurface;
